<template>
  <div class="prototype-page">
    <div class="app-shell">
      <header class="page-header">
        <div class="header-inner">
          <div class="logo">
            <div class="logo-badge">3P</div>
            <span class="site-title">3P影视</span>
          </div>
          <div class="domain-display">
            <div class="domain-slider">
              <span v-for="(domain, idx) in domains" :key="idx" class="domain-item">{{ domain }}</span>
            </div>
          </div>
          <div class="header-action" @click="handleHeaderAction">{{ currentUser.username || '登录' }}</div>
        </div>
     
      </header>

      <section class="info-card">
        <div class="profile-card" @click="handleHeaderAction">
          <div class="avatar">{{ avatarText }}</div>
          <div>
            <h2 class="profile-name">{{ currentUser.username || '未登录用户' }}</h2>
            <span class="muted-text">{{ isLoggedIn ? userSubText : '点击登录 / 注册' }}</span>
          </div>
        </div>
      </section>

      <section class="info-card">
        <div class="section-title">
          <h2>账号入口</h2>
        </div>
        <div class="form-actions">
          <button class="btn" type="button" @click="handlePrimaryAction">{{ isLoggedIn ? '退出登录' : '立即登录' }}</button>
          <button class="ghost-btn" type="button" @click="handleSecondaryAction">{{ isLoggedIn ? '收藏海报' : '注册账号' }}</button>
        </div>
      </section>

      <!-- <section class="info-card">
        <div class="section-title">
          <h2>快捷功能</h2>
        </div>
        <div class="quick-grid">
          <div class="quick-link" @click="handleQuickAction('收藏')">
            <strong>我的收藏</strong>
            <span>登录后查看已收藏内容</span>
          </div>
          <div class="quick-link" @click="handleQuickAction('记录')">
            <strong>观看记录</strong>
            <span>查看最近浏览历史</span>
          </div>
          <div class="quick-link" @click="handleQuickAction('设置')">
            <strong>账号设置</strong>
            <span>修改信息与密码</span>
          </div>
          <div class="quick-link" @click="copyLink">
            <strong>收藏本站</strong>
            <span>复制链接防止失联</span>
          </div>
        </div>
        <div class="helper-text" :class="feedbackClass" style="margin-top: 12px;">
          {{ feedbackText }}
        </div>
      </section> -->

      <section class="section">
        <div class="section-title">
          <h2>我的页广告</h2>
        </div>
      </section>
      <div class="stack-list">
        <router-link
          v-for="(ad, index) in mineAds"
          :key="ad.id"
          class="home-reference-banner"
          :style="adStyle(index + 10)"
          :to="ad.url || `/detail?id=${(ad.id % videos.length) + 1}`"
        >
          <span class="home-reference-banner__text">
            <em :style="{ color: adTagColor(index + 10) }">【{{ ad.title.split(' ')[0] || '推荐' }}】</em>
            <strong>{{ ad.title }}</strong>
          </span>
          <span class="home-reference-banner__arrow">›</span>
        </router-link>
      </div>
    </div>

    <nav class="bottom-nav">
      <router-link
        v-for="item in navItems"
        :key="item.key"
        class="nav-item"
        :class="{ active: item.key === 'mine' }"
        :to="item.to"
      >
        <div v-html="item.svg" class="nav-icon"></div>
        <span>{{ item.label }}</span>
      </router-link>
    </nav>
    <!-- 海报弹窗-->
    <van-dialog class="demo-dialog van-dialog detail-box" v-model="showFavoritePopup" :style="{ height: '540px' }"
      :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true">
      <Sposter :params="params" @save-close="closePoster"></Sposter>
    </van-dialog>
    <AuthModal
      v-if="authVisible"
      :mode="authMode"
      @close="closeAuth"
      @change-mode="authMode = $event"
      @success="handleAuthSuccess"
    />
  </div>
</template>

<script>
import AuthModal from "@/views/AuthModal.vue";
import { navItems } from "@/prototype/navigation";
import { getAdsListApi } from "@/api/api";
import { copyCurrentLink, decryptApiPayload, getBannerUrl, getCachedNavUrlList } from "@/prototype/render-helpers";
import { siteData } from "@/prototype/site-data";
import Sposter from '@/components/sposter.vue';
export default {
  name: "MinePage",
  components: {
    AuthModal,
    Sposter,
  },
  data() {
    return {
      showFavoritePopup: false,
      apiAds: [],
      domains: getCachedNavUrlList(),
      currentUser: { id: "", username: "", token: "", viptime: "" },
      authVisible: false,
      authMode: "login",
      feedbackText: "建议及时保存当前地址。",
      feedbackType: "",
      navItems,
      siteData,
    };
  },
  computed: {
    mineAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 4).slice(0, 5);
    },
    videos() {
      return this.siteData.videos;
    },
    feedbackClass() {
      if (this.feedbackType === "success") return "success-text";
      if (this.feedbackType === "error") return "error-text";
      return "";
    },
    isLoggedIn() {
      return !!(this.currentUser && this.currentUser.id);
    },
    avatarText() {
      return this.currentUser.username ? this.currentUser.username.slice(0, 1).toUpperCase() : "未";
    },
    userSubText() {
      return this.currentUser.viptime ? `VIP到期：${this.currentUser.viptime}` : "已登录，可查看账号相关信息";
    },
  },
  mounted() {
    this.refreshAuthState();
    this.fetchAds();
    window.addEventListener("auth-changed", this.refreshAuthState);
  },
  beforeDestroy() {
    window.removeEventListener("auth-changed", this.refreshAuthState);
  },
  methods: {
    async fetchAds() {
      try {
        const res = await getAdsListApi({ limit: 100 });
        const list = decryptApiPayload(res, this.$decryptData);
        if (Array.isArray(list)) {
          this.apiAds = list;
        }
      } catch (error) {
        console.error("Failed to fetch ads", error);
      }
    },
    getBannerUrl,
    adStyle(index) {
      const palette = this.siteData.adPalette[index % this.siteData.adPalette.length];
      return {
        background: palette.bg,
        color: palette.text,
      };
    },
    adTagColor(index) {
      return this.siteData.adPalette[index % this.siteData.adPalette.length].tag;
    },
    refreshAuthState() {
      try {
        const userInfo = window.localStorage.getItem("userInfo");
        this.currentUser = userInfo ? JSON.parse(userInfo) : { id: "", username: "", token: "", viptime: "" };
      } catch (error) {
        this.currentUser = { id: "", username: "", token: "", viptime: "" };
      }
    },
    handleHeaderAction() {
      if (this.isLoggedIn) {
        this.feedbackType = "success";
        this.feedbackText = `当前账号：${this.currentUser.username}`;
        return;
      }
      this.openAuth("login");
    },
    openAuth(mode) {
      this.authMode = mode;
      this.authVisible = true;
    },
    closeAuth() {
      this.authVisible = false;
    },
    handleAuthSuccess(user) {
      this.currentUser = user || this.currentUser;
      this.refreshAuthState();
      this.feedbackType = "success";
      this.feedbackText = `欢迎你，${this.currentUser.username || "用户"}。`;
      this.closeAuth();
    },
    handlePrimaryAction() {
      if (!this.isLoggedIn) {
        this.openAuth("login");
        return;
      }
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("userid");
      window.localStorage.removeItem("userInfo");
      window.dispatchEvent(new Event("auth-changed"));
      this.refreshAuthState();
      this.feedbackType = "success";
      this.feedbackText = "已退出登录。";
    },
    async handleSecondaryAction() {
      if (!this.isLoggedIn) {
        this.openAuth("register");
        return;
      }
      this.showFavoritePopup = true;
    },
    handleQuickAction(action) {
      if (!this.isLoggedIn) {
        this.openAuth("login");
        return;
      }
      this.feedbackType = "success";
      this.feedbackText = `${action} 功能已登录，可继续接真实接口。`;
    },
    async copyLink() {
      try {
        await copyCurrentLink();
        this.feedbackType = "success";
        this.feedbackText = "链接已复制，请尽快保存到浏览器收藏夹或备忘录。";
      } catch (error) {
        this.feedbackType = "error";
        this.feedbackText = "当前环境未能自动复制，请手动复制地址栏链接。";
      }
    },
  },
};
</script>
